module.exports = __webpack_public_path__ + "static/media/sax-hot.29abe14a.svg";